// ============================================================================
// REDUCER - componentLibraryReducer.js
// ============================================================================
// ./context/componentLibrary/componentLibraryReducer.js

import { CourseDomains } from '../../types/courseDomains';

const allCategoryKeys = [
  ...new Set(
    Object.values(CourseDomains)
      .flatMap(domain => domain.canvases)
      .flatMap(canvas => canvas.categories)
      .map(cat => cat.key)
  )
];

const emptyComponentsByCategory = Object.fromEntries(
  allCategoryKeys.map(key => [key, []])
);

const componentLibraryReducer = (state, { type, payload }) => {
    switch (type) {
        // Loading State
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload,
                error: null
            };

        // Component Management
        case 'SET_COMPONENTS':
            return {
                ...state,
                components: payload,
                isLoading: false,
                error: null
            };

        case 'SET_CURRENT_COMPONENT':
            return {
                ...state,
                currentComponent: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_COMPONENT':
            return {
                ...state,
                components: [...state.components, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_COMPONENT':
            return {
                ...state,
                components: state.components.map(c =>
                    c.componentId === payload.componentId ? payload : c
                ),
                currentComponent: state.currentComponent?.componentId === payload.componentId 
                    ? payload 
                    : state.currentComponent,
                isLoading: false,
                error: null
            };

        case 'DELETE_COMPONENT':
            return {
                ...state,
                components: state.components.filter(c => c.componentId !== payload),
                currentComponent: state.currentComponent?.componentId === payload 
                    ? null 
                    : state.currentComponent,
                isLoading: false,
                error: null
            };

        // Filter by Category
        case 'SET_COMPONENTS_BY_CATEGORY':
            return {
                ...state,
                componentsByCategory: {
                    ...state.componentsByCategory,
                    [payload.category]: payload.components
                },
                isLoading: false,
                error: null
            };

        case 'SET_ALL_COMPONENTS_BY_CATEGORY':
            return {
                ...state,
                componentsByCategory: payload,
                isLoading: false,
                error: null
            };

        case 'SET_SEARCH_RESULTS':
            return {
                ...state,
                searchResults: payload,
                isLoading: false,
                error: null
            };

        case 'CLEAR_SEARCH_RESULTS':
            return {
                ...state,
                searchResults: [],
                error: null
            };

        // Error Handling
        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_ERROR':
            return {
                ...state,
                error: null
            };

        // Clear Data
        case 'CLEAR_CURRENT_COMPONENT':
            return {
                ...state,
                currentComponent: null
            };

            case 'CLEAR_DATA':
            return {
                components: [],
                currentComponent: null,
                componentsByCategory: emptyComponentsByCategory,
                searchResults: [],
                bulkImport: {
                isChecking: false,
                isImporting: false,
                duplicates: [],
                importResult: null
                },
                isLoading: false,
                error: null
            };
                    
  // ============================================================================
        // BULK IMPORT OPERATIONS
        // ============================================================================

        case 'SET_CHECKING_DUPLICATES':
            return {
                ...state,
                bulkImport: {
                    ...state.bulkImport,
                    isChecking: payload
                }
            };

        case 'SET_DUPLICATES':
            return {
                ...state,
                bulkImport: {
                    ...state.bulkImport,
                    duplicates: payload,
                    isChecking: false
                }
            };

        case 'SET_IMPORTING':
            return {
                ...state,
                bulkImport: {
                    ...state.bulkImport,
                    isImporting: payload
                }
            };

        case 'SET_IMPORT_RESULT':
            return {
                ...state,
                bulkImport: {
                    ...state.bulkImport,
                    importResult: payload,
                    isImporting: false
                }
            };

        case 'CLEAR_IMPORT_DATA':
            return {
                ...state,
                bulkImport: {
                    isChecking: false,
                    isImporting: false,
                    duplicates: [],
                    importResult: null
                }
            };

        case 'BULK_ADD_COMPONENTS':
            return {
                ...state,
                components: [...state.components, ...payload],
                isLoading: false,
                error: null
            };


        default:
            return state;
    }
};

export default componentLibraryReducer;